import React from "react";
import MMBViewer from "./mmb.js";
import History from "./history.js";
import {
  MMB,
  MMB_INDEX,
  NUM_OF_CHARTS,
  NUM_OF_CHARTS_CHANGE_EVENT,
  ENERGY_SYMBOL,
} from "./constants.js";
import {
  getMarketCalendar,
  getEffectiveNumOfCharts,
  setStoredNumOfCharts,
} from "./utils.js";
import "./combined-live-view.css";

// In the two grid layout the mmb column shares the row with two energy tables,
// so it is capped at half of the window width.
const TWO_GRID_MMB_WIDTH_RATIO = 0.5;

export default class CombinedLiveView extends React.Component {
  constructor(props) {
    super(props);

    // A numOfCharts query param wins for this load, otherwise the layout picked
    // last time in the settings menu is restored.
    const effectiveNumOfCharts = getEffectiveNumOfCharts();
    setStoredNumOfCharts(effectiveNumOfCharts);

    this.state = {
      numOfCharts: parseInt(effectiveNumOfCharts),
      mmb1: this.getEffectiveMMB(MMB_INDEX.MMB1, MMB.SPY),
      mmb2: this.getEffectiveMMB(MMB_INDEX.MMB2, MMB.SPX),
      mmb3: this.getEffectiveMMB(MMB_INDEX.MMB3, MMB.QQQ),
      mmb4: this.getEffectiveMMB(MMB_INDEX.MMB4, MMB.IWM),
      mmb1TwoGrid: this.getEffectiveMMB(MMB_INDEX.MMB1_TWO_GRID, MMB.SPY),
      mmb2TwoGrid: this.getEffectiveMMB(MMB_INDEX.MMB2_TWO_GRID, MMB.QQQ),
      isPortrait: window.innerWidth < window.innerHeight,
      initComplete: false,
      marketCalendar: {},
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener(NUM_OF_CHARTS_CHANGE_EVENT, this.handleNumOfChartsChange);
    getMarketCalendar().then(res => {
      this.setState({ marketCalendar: res, initComplete: true });
    }).catch(err => {
      this.setState({ initComplete: true });
    });
  }

  componentWillUnmount() {
    // 清理监听器
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener(NUM_OF_CHARTS_CHANGE_EVENT, this.handleNumOfChartsChange);
  }

  handleResize = () => {
    this.setState({
      isPortrait: window.innerWidth < window.innerHeight
    });
  };

  handleNumOfChartsChange = (event) => {
    const numOfCharts = event.detail;
    this.setState({ numOfCharts: parseInt(numOfCharts) });
  };

  getEffectiveMMB(mmbIndex, defaultMMB) {
    const storedSymbol = localStorage.getItem(mmbIndex);
    const resolvedSymbol = storedSymbol || defaultMMB.symbol;
    const mmb = this.findMMBBySymbol(resolvedSymbol);
    const effectiveMMB = mmb ? mmb : defaultMMB;
    if (effectiveMMB.symbol !== defaultMMB.symbol) {
      localStorage.setItem(mmbIndex, effectiveMMB.symbol);
    }
    return effectiveMMB;
  }

  findMMBBySymbol(symbol) {
    for (var key in MMB) {
      var mmb = MMB[key];
      if (mmb.symbol === symbol) {
        return mmb;
      }
    }
    return null;
  }

  renderTwoGrid(marketCalendar, isPortrait) {
    return (
      <div key="two-grid" className={`combined-view ${isPortrait ? 'portrait' : 'landscape'}`}>
        <div className="mmb-section">
          <MMBViewer
            key={MMB_INDEX.MMB1_TWO_GRID}
            mmb={this.state.mmb1TwoGrid}
            mmbIndex={MMB_INDEX.MMB1_TWO_GRID}
            marketCalendar={marketCalendar}
            maxWidthRatio={TWO_GRID_MMB_WIDTH_RATIO}
          />
          <MMBViewer
            key={MMB_INDEX.MMB2_TWO_GRID}
            mmb={this.state.mmb2TwoGrid}
            mmbIndex={MMB_INDEX.MMB2_TWO_GRID}
            marketCalendar={marketCalendar}
            maxWidthRatio={TWO_GRID_MMB_WIDTH_RATIO}
          />
        </div>
        <div className={`energy-section dual ${isPortrait ? 'portrait' : 'landscape'}`}>
          <div className="energy-pane">
            <History
              key={ENERGY_SYMBOL.SPY}
              isEnergy={true}
              isLive={true}
              energySymbol={ENERGY_SYMBOL.SPY}
              marketCalendar={marketCalendar}
            />
          </div>
          <div className="energy-pane">
            <History
              key={ENERGY_SYMBOL.QQQ}
              isEnergy={true}
              isLive={true}
              energySymbol={ENERGY_SYMBOL.QQQ}
              marketCalendar={marketCalendar}
            />
          </div>
        </div>
      </div>
    );
  }

  renderFourGrid(marketCalendar, isPortrait) {
    return (
      <div key="four-grid" className={`combined-view ${isPortrait ? 'portrait' : 'landscape'}`}>
        <div className="mmb-section">
          <MMBViewer key={MMB_INDEX.MMB1} mmb={this.state.mmb1} mmbIndex={MMB_INDEX.MMB1} marketCalendar={marketCalendar}/>
          <MMBViewer key={MMB_INDEX.MMB2} mmb={this.state.mmb2} mmbIndex={MMB_INDEX.MMB2} marketCalendar={marketCalendar}/>
        </div>
        <div className="right-block">
          <MMBViewer key={MMB_INDEX.MMB3} mmb={this.state.mmb3} mmbIndex={MMB_INDEX.MMB3} marketCalendar={marketCalendar}/>
          <MMBViewer key={MMB_INDEX.MMB4} mmb={this.state.mmb4} mmbIndex={MMB_INDEX.MMB4} marketCalendar={marketCalendar}/>
        </div>
        <div className={`energy-section ${isPortrait ? 'portrait' : 'landscape'}`}>
          <History isEnergy={true} isLive={true} marketCalendar={marketCalendar}/>
        </div>
      </div>
    );
  }

  render() {
    const { isPortrait, marketCalendar, initComplete, numOfCharts } = this.state;

    if (!initComplete) {
      return false;
    }

    return numOfCharts === parseInt(NUM_OF_CHARTS.TWO)
      ? this.renderTwoGrid(marketCalendar, isPortrait)
      : this.renderFourGrid(marketCalendar, isPortrait);
  }
}
